// extracted by mini-css-extract-plugin
export var activePage = "styles-module--activePage--rsMxg";
export var container = "styles-module--container--w7R3q";
export var disabledLink = "styles-module--disabledLink--PA1au";
export var listItem = "styles-module--listItem--rPrEQ";
export var swiped = "styles-module--swiped--HWoS6";
export var unswiped = "styles-module--unswiped--W1j3I";